var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"space-y-1"},[_c('nio-progress',{attrs:{"color":_vm.usageColor,"percentage":_vm.usage}}),_c('div',{staticClass:"text-sm whitespace-no-wrap",domProps:{"textContent":_vm._s(_vm.segmentLimitText)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }